/**
 * Утилита для работы с типами медиа (клиентская часть)
 * Использует общий файл shared/mediaTypes.json для синхронизации с сервером
 */

import mediaTypesData from '../../../shared/mediaTypes.json';

const MEDIA_TYPES = mediaTypesData.MEDIA_TYPES;
const MEDIA_TYPE_LABELS = mediaTypesData.MEDIA_TYPE_LABELS;
const SENSITIVE_MEDIA_TYPES = mediaTypesData.SENSITIVE_MEDIA_TYPES || [];

/**
 * Получить массив всех типов медиа с лейблами
 * @returns {Array<{value: string, label: string}>}
 */
const getAllMediaTypes = () => {
  return Object.values(MEDIA_TYPES).map(value => ({
    value,
    label: MEDIA_TYPE_LABELS[value]
  }));
};

/**
 * Константы типов медиа
 */
export { MEDIA_TYPES, MEDIA_TYPE_LABELS, SENSITIVE_MEDIA_TYPES };

/**
 * Список всех доступных типов медиа для использования в компонентах
 */
export const mediaTypes = getAllMediaTypes();

/**
 * Получить лейбл типа медиа по значению
 * @param {string} value - Значение типа медиа
 * @returns {string} - Лейбл типа медиа или сам value если не найден
 */
export const getMediaTypeLabel = (value) => {
  return MEDIA_TYPE_LABELS[value] || value;
};

/**
 * Получить объект типа медиа по значению
 * @param {string} value - Значение типа медиа
 * @returns {object|null} - Объект типа медиа или null если не найден
 */
export const getMediaType = (value) => {
  return mediaTypes.find(type => type.value === value) || null;
};

/**
 * Проверить, существует ли тип медиа
 * @param {string} value - Значение типа медиа
 * @returns {boolean} - true если тип существует
 */
export const isValidMediaType = (value) => {
  return Object.values(MEDIA_TYPES).includes(value);
};

/**
 * Получить типы медиа для select компонента
 * @returns {array} - Массив объектов для react-select
 */
export const getMediaTypesForSelect = () => {
  return mediaTypes;
};
